import stores from '../../api/stores'
import stocks from '../../api/stocks'

export default {
    namespaced: true,
    state: () => ({
        stockLoading: true,
        selected: null,
        popup: false,
        loading: false,
        limited: 1,
        items: []
    }),
    getters: {},
    actions: {
        getStocks ({ commit }, data) {
            commit('setStockLoading', true)
            return stocks.getStocks(data).then((response) => {
                commit('updateStocks', response.data.stocks)
                commit('setLimited', response.data.limited)
                commit('setStockLoading', false)
            })
        },
        getStores ({ commit }, data) {
            return stores.getStores(data).then((response) => {
                commit('setItems', response.data.stores)
                commit('setLoading', false)
                commit('setStockLoading', false)
            })
        },
        initGeolocation ({ commit }) {
            commit('setLoading', true)
            return new Promise((resolve, reject) => {
                if (window.navigator.geolocation) {
                    window.navigator.geolocation.getCurrentPosition((response) => {
                        resolve([response.coords.longitude, response.coords.latitude])
                    }, (response) => {
                        if(response.code === 1) console.error('You have to enable geolocation if you want to see nearest stores')
                        resolve(null)
                    },{
                        enableHighAccuracy: true,
                        timeout: 5000,
                        maximumAge: 0
                    })
                } else {
                    resolve(null)
                }
            })
        },
        openPopup ({ commit }) {
            commit('setPopup', true)
        },
        closePopup ({ commit }) {
            commit('setPopup', false)
        },
        setStore ({ commit }, code) {
            commit('setStore', code)
            stores.setPreferredStore({ code: code })
        }
    },
    mutations: {
        setLoading (state, bool) {
            state.loading = bool
        },
        setStockLoading (state, bool) {
            state.stockLoading = bool
        },
        setItems (state, data) {
            state.items = data
        },
        setPopup (state, bool) {
            state.popup = bool
        },
        setLimited (state, value) {
            state.limited = value
        },
        setStore (state, code) {
            state.selected = code
        },
        updateStocks (state, data) {
            const stores = []

            state.items.forEach((store) => {

                const newStore = store
                newStore.stock = 0

                data.forEach((stock) => {
                    if(newStore.code === stock.code){
                        newStore.stock = stock.stock
                    }
                })

                stores.push(newStore)

            })

            state.items = stores
        }
    }
}
